<script>
import {mergeData} from 'vue-functional-data-merge'
import {renderHeader} from './utils'

export default {
  name: 'Card',
  props: {
    title: {
      type: String
    },
    /**
     * An array of action objects:
     *
     * ```js
     * [
     *   {
     *     label: 'Options',
     *     onAction: () => {}
     *   }
     * ]
     * ```
     */
    actions: {
      type: Array
    },
    subdued: {
      type: Boolean
    },
    sticky: {
      type: Boolean
    }
  },
  functional: true,
  render(h, {props, data, children, $style}) {
    const header = renderHeader(h, props, $style)
    // if (props.sticky) {
    // }
    return h('div', mergeData(data, {
      class: [
        'UIElement',
        data.staticClass,
        data.class,
        $style.Card,
        props.subdued && $style.subdued
      ],
      attrs: data.attrs
    }), [
      header,
      children
    ])
  }
}
</script>

<style lang="scss" module>
@import "../../styles/variables";

.Card {
  // overflow: hidden;
  background: #fff;
  // border: 1px solid #e7e9ec;
  border-radius: 3px;
  box-shadow:
    0 0 0 1px rgba(63, 63, 68, .05),
    0 1px 3px 0 rgba(63, 63, 68, .15);
}

.header {
  display: flex;
  align-items: center;
  padding: $s4 $s4 0;
}

.actions {
  margin-left: auto;
}

.action + .action {
  margin-left: 4px;
}

.title {
  flex: 1 1 auto;
  color: #212b36;
  font-size: 17px;
  font-weight: 500;
}

.subdued {
  background: #f9fafb;
}

.Card + .Card {
  margin-top: 20px;
}
</style>
